import { ref } from 'vue'

export function useDebounce(fn, delay = 300) {
  const timeoutId = ref(null)

  return () => {
    if (timeoutId.value) {
      clearTimeout(timeoutId.value)
    }

    timeoutId.value = setTimeout(() => {
      fn()
      timeoutId.value = null
    }, delay)

    return () => {
      if (timeoutId.value) {
        clearTimeout(timeoutId.value)
        timeoutId.value = null
      }
    }
  }
}

export function useThrottle(fn, delay = 500) {
  const timeoutId = ref(null)

  return () => {
    if (timeoutId.value) {
      return
    }

    fn()
    timeoutId.value = setTimeout(() => { timeoutId.value = null }, delay)
  }
}
